/* CacheBuster component */
import packageJson from '../../package.json';
import React from 'react';
import { SemanticVersion, semverGreaterThan } from './version';

declare global {
  var appVersion: SemanticVersion;
}
globalThis.appVersion = packageJson.version as SemanticVersion;

const forceReload = () => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = window.location.href;
  document.body.appendChild(form);
  form.submit();
};

const refreshCacheAndReload = () => {
  console.log('Clearing cache and hard reloading...');
  if (caches) {
    // Service worker cache should be cleared with caches.delete()
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });
  }
  // delete browser cache and hard reload
  forceReload();
};

interface RendererProps {
  loading: boolean;
  isLatestVersion: boolean;
  refreshCacheAndReload: () => void;
}

interface Props {
  renderer: (props: RendererProps) => JSX.Element | null;
}

export const CacheBuster = ({ renderer }: Props) => {
  const [loading, setLoading] = React.useState(true);
  const [isLatestVersion, setIsLatestVersion] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const response = await fetch('/meta.json');
      const meta = await response.json();

      const latestVersion = meta.version;
      const currentVersion = globalThis.appVersion;
      const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

      if (shouldForceRefresh) {
        console.log(`We have a new version - ${latestVersion}. Should force refresh`);
        setIsLatestVersion(false);
      } else {
        console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
        setIsLatestVersion(true);
      }
      setLoading(false);
    })();
  }, []);

  return renderer({ loading, isLatestVersion, refreshCacheAndReload });
};
